import React from 'react';
import { Stars } from './Stars';
const opinions = [{
  name: 'Dra. Agustina Robledo',
  city: 'Rosario, Santa Fe',
  text: 'Lo bajé un domingo y el lunes ya estaba usando la agenda y el presupuesto. Todo en Excel, sin vueltas ni programas raros.'
}, {
  name: 'Dr. Nicolás Ibarra',
  city: 'Córdoba Capital',
  text: 'Recién recibido, no tenía idea de cómo poner precios. Con la calculadora de costo por hora entendí el negocio en una tarde.'
}, {
  name: 'Dra. Verónica Maldonado',
  city: 'La Plata, Buenos Aires',
  text: 'Tengo dos sillones y alquilo uno. Los modelos de contrato me ahorraron plata en el estudio jurídico.'
}, {
  name: 'Dr. Sebastián Quiroga',
  city: 'Mendoza',
  text: 'La presentación del plan de tratamiento me subió muchísimo la aceptación de presupuestos. El paciente entiende y dice que sí.'
}];
export function Opinions() {
  return <section className="px-5 py-10" aria-label="Opiniones de clientes" data-id="element-149" data-mp="3055ser13w7bv">
      <h2 className="text-center text-xl font-black text-white" data-id="element-150" data-mp="15qcoyslasw84">
        Lo que dicen los que ya lo están usando
      </h2>

      <div className="mt-5 space-y-3" data-id="element-151" data-mp="10qhy2p1iw6n2">
        {opinions.map(o => <article key={o.name} className="rounded-2xl border border-white/10 bg-white/5 p-4" data-id="element-152" data-mp="1fg5ylo1vr19q">
            <Stars size={14} data-id="element-153" data-mp="1aidza8ywocvi" />
            <p className="mt-2 text-sm leading-relaxed text-teal-50/90" data-id="element-154" data-mp="1ajfkh69myfqy">
              “{o.text}”
            </p>
            <p className="mt-2 text-xs font-semibold text-teal-200" data-id="element-155" data-mp="mtl7mopbgr6p">
              {o.name} · <span className="font-normal" data-id="element-156" data-mp="hui10ztoucwm">{o.city}</span>
            </p>
          </article>)}
      </div>
    </section>;
}